<template>
  <RawRecords v-if="showRawOutput" :records="records" />
  <table v-else-if="processedRecords.length">
    <colgroup>
      <col class="w-2/4">
      <col class="w-1/4">
      <col class="w-1/4">
    </colgroup>
    <thead>
      <tr class="border-b-2 border-gray-200 text-left">
        <th scope="col" class="py-1.5 font-medium">Mail server</th>
        <th scope="col" class="py-1.5 font-medium">Priority</th>
        <th scope="col" class="py-1.5 font-medium">Revalidate in</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(record, index) in processedRecords" :key="index" class="group">
        <td class="py-1">
          <span v-if="isTheSameDomain(records.query.domain, record.record.target)">{{ record.record.target }}</span>
          <dns-records-link v-else :domain="record.record.target" class="text-blue-600 hover:text-blue-800 hover:underline break-all" />
          <CnameChainBadge :chain="record.cnameChain" />
          <copy :content="record.record.target " class="[visibility:hidden] group-hover:visible" /></td>
        <td class="py-1"><span>{{record.record.priority}}</span> <span v-if="record.record.priority === minPriority" class="inline-flex items-center rounded-full bg-blue-100 px-2.5 py-0.5 text-xs font-medium text-blue-800">
          Primary</span></td>
        <td class="py-1"><duration :seconds="record.record.ttl" /></td>
      </tr>
    </tbody>
  </table>
  <div v-else>No mail servers found.</div>
</template>

<script setup lang="ts">
import { computed, PropType } from 'vue';
import { useStore } from 'vuex';
import { isTheSameDomain } from '@/common/domainName';
import Duration from '@/components/micro/DurationComponent.vue';
import Copy from '@/components/micro/CopyComponent.vue';
import RawRecords from '@/components/micro/RawRecords.vue';
import CnameChainBadge from '@/components/micro/CnameChainBadge.vue';
import DnsRecordsLink from '@/components/micro/DnsRecordsLink.vue';
import { MX, QueryResult, RecordInfo } from '@/model/Api';

type MxRecordWithInfo = {
  record: MX;
} & RecordInfo

const props = defineProps({
  records: {
    type: Object as PropType<QueryResult>,
    required: true,
  },
});

const store = useStore();
const showRawOutput = computed(() => store.state.showRawOutput);

const processedRecords = computed(() => {
  const processed: MxRecordWithInfo[] = props.records.response.answer.filter((item): item is MxRecordWithInfo => item.record.recordType === 'MX');
  processed.sort((a, b) => a.record.priority - b.record.priority);

  return processed;
});

const minPriority = computed(() => Math.min(...processedRecords.value.map((r) => r.record.priority)));
</script>
